module.exports = __webpack_public_path__ + "img/recommendation.93bdbb57.png";